import { css } from 'styled-components'

const has = v => !!v || Number.isFinite(v)

const getTypeStyle =
	name =>
	({ theme }) => {
		const props = theme.typography.scale?.[name] || {}
		const { fontSize, fontWeight, lineHeight, letterSpacing, textTransform, ...rest } = props

		return [
			has(fontSize) && `font-size: ${fontSize}`,
			has(fontWeight) && `font-weight: ${fontWeight}`,
			has(lineHeight) && `line-height: ${lineHeight}`,
			has(letterSpacing) && `letter-spacing: ${letterSpacing}`,
			has(textTransform) && `text-transform: ${textTransform}`,
			css(rest).join(''), // media queries etc
		]
			.filter(x => !!x)
			.join(';\n')
	}

export default getTypeStyle
